import styled from 'styled-components'
import { Label } from '../../components/common/Label'

export const MoreDetailsHelperImage = styled.img`
  width: 50%;
  height: 30%;
  margin: 1em 0 0 0;
  @media (max-width: 767px) and (orientation: portrait) {
    width: 70%;
    height: 50%;
  }
  @media (max-width: 850px) and (orientation: landscape) {
    width: 40%;
    height: 30%;
  }
`

export const MoreDetailsLabel = styled(Label)`
  margin-top: 1em;
  font-weight: 600;
`

export const MoreDetailsHelpH3 = styled.h3`
  margin: 1em 0;
  font-weight: 500;
`
export const MoreDetailsHelpP = styled.p`
  margin: 1em 0;
  text-wrap: balance;
`
